import {Component, OnInit, inject} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {debounceTime} from 'rxjs/operators';
import {FilterService} from '../../../services/filter.service';

@Component({
  selector: 'app-caregiver-performance-grid-search',
  templateUrl: './caregiver-performance-grid-search.component.html',
  styleUrls: ['./caregiver-performance-grid-search.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class CaregiverPerformanceGridSearchComponent implements OnInit {
  private filterService = inject(FilterService);
  private formBuilder = inject(FormBuilder);

  caregiverSearchFormGroup: FormGroup;

  ngOnInit() {
    this.initializeForm();
    this.subscribeToFormChanges();
    this.subscribeToFilterSelectionChanges();
  }

  resetForm(): void {
    this.caregiverSearchFormGroup.patchValue({
      caregiverNameSearch: '',
    });
  }

  get searchValue(): string {
    return this.caregiverSearchFormGroup.value.caregiverNameSearch.trim();
  }

  private initializeForm(): void {
    this.caregiverSearchFormGroup = this.formBuilder.group({
      caregiverNameSearch: [''],
    });
  }

  private subscribeToFormChanges(): void {
    this.caregiverSearchFormGroup.valueChanges
      .pipe(debounceTime(300))
      .subscribe((valueChanged) => {
        if (this.searchValue === '') {
          this.filterService.removeFilter('caregiverSearch');
          return;
        }
        this.filterService.addFilter('caregiverSearch', this.searchValue);
      });
  }

  private subscribeToFilterSelectionChanges(): void {
    this.filterService.currentSelectionsChange$.subscribe(() => {
      if (
        this.filterService.currentSelections.caregiverSearch === undefined &&
        this.searchValue !== ''
      ) {
        this.resetForm();
      }
    });
  }
}
